export class RequestProperty{
    userId: string;

    constructor(userId: string){
        this.userId = userId;
    }
}